import { Link } from "react-router-dom";

export default function BlogCard({ post }) {
  const image = post.cover_image || "/plant-placeholder.png";
  const date = post.created_at
    ? new Date(post.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })
    : "";

  return (
    <div data-testid={`blog-card-${post.id}`} className="card-hover group bg-white rounded-2xl border border-[var(--yp-border)] overflow-hidden flex flex-col">
      <Link to={`/blogs/${post.id}`} className="relative aspect-[4/5] bg-[var(--yp-surface-alt)] overflow-hidden">
        <img src={image} alt={post.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-500" />
      </Link>
      <div className="p-4 flex flex-col gap-2 flex-1">
        {date && <div className="text-xs uppercase tracking-widest text-[var(--yp-muted)]">{date}</div>}
        <Link to={`/blogs/${post.id}`} className="font-serif-display text-lg leading-tight text-[var(--yp-text)] hover:text-[var(--yp-primary)]">
          {post.title}
        </Link>
        {post.excerpt && (
          <p className="text-sm text-[var(--yp-muted)] leading-relaxed line-clamp-3">{post.excerpt}</p>
        )}
      </div>
    </div>
  );
}
